const Copyright = () => {
    return(
        <>
            <div className='copyright'>
                <p>©️2024 St. Thomas School | Designed and Developed by Entab Infotech : CampusCare®️ </p>
            </div>
        </>
    )
}
export default Copyright